{
  "languageCode": "es",
  "name": "Español",
  "direction": "ltr",
  "minimumWordLength": 2,
  "maximumWordLength": 12,
  "groups": [
    {
      "id": "vowel",
      "minimum": 5,
      "maximum": 8
    },
    {
      "id": "consonant",
      "minimum": 4,
      "maximum": 6
    }
  ],
  "letters": [
    {
      "id": "es-0",
      "symbol": "a",
      "points": 1,
      "group": "vowel",
      "weight": 14.87,
      "enabled": true,
      "sortOrder": 0
    },
    {
      "id": "es-1",
      "symbol": "b",
      "points": 3,
      "group": "consonant",
      "weight": 1.94,
      "enabled": true,
      "sortOrder": 1
    },
    {
      "id": "es-2",
      "symbol": "c",
      "points": 2,
      "group": "consonant",
      "weight": 5.48,
      "enabled": true,
      "sortOrder": 2
    },
    {
      "id": "es-3",
      "symbol": "d",
      "points": 2,
      "group": "consonant",
      "weight": 3.69,
      "enabled": true,
      "sortOrder": 3
    },
    {
      "id": "es-4",
      "symbol": "e",
      "points": 1,
      "group": "vowel",
      "weight": 9.42,
      "enabled": true,
      "sortOrder": 4
    },
    {
      "id": "es-5",
      "symbol": "f",
      "points": 4,
      "group": "consonant",
      "weight": 1.09,
      "enabled": true,
      "sortOrder": 5
    },
    {
      "id": "es-6",
      "symbol": "g",
      "points": 3,
      "group": "consonant",
      "weight": 1.83,
      "enabled": true,
      "sortOrder": 6
    },
    {
      "id": "es-7",
      "symbol": "h",
      "points": 4,
      "group": "consonant",
      "weight": 1.14,
      "enabled": true,
      "sortOrder": 7
    },
    {
      "id": "es-8",
      "symbol": "i",
      "points": 1,
      "group": "vowel",
      "weight": 8.33,
      "enabled": true,
      "sortOrder": 8
    },
    {
      "id": "es-9",
      "symbol": "j",
      "points": 5,
      "group": "consonant",
      "weight": 0.74,
      "enabled": true,
      "sortOrder": 9
    },
    {
      "id": "es-10",
      "symbol": "k",
      "points": 10,
      "group": "consonant",
      "weight": 0.25,
      "enabled": true,
      "sortOrder": 10
    },
    {
      "id": "es-11",
      "symbol": "l",
      "points": 2,
      "group": "consonant",
      "weight": 5.04,
      "enabled": true,
      "sortOrder": 11
    },
    {
      "id": "es-12",
      "symbol": "m",
      "points": 3,
      "group": "consonant",
      "weight": 2.97,
      "enabled": true,
      "sortOrder": 12
    },
    {
      "id": "es-13",
      "symbol": "n",
      "points": 2,
      "group": "consonant",
      "weight": 5.75,
      "enabled": true,
      "sortOrder": 13
    },
    {
      "id": "es-14",
      "symbol": "ñ",
      "points": 8,
      "group": "consonant",
      "weight": 0.31,
      "enabled": true,
      "sortOrder": 14
    },
    {
      "id": "es-15",
      "symbol": "o",
      "points": 1,
      "group": "vowel",
      "weight": 10.32,
      "enabled": true,
      "sortOrder": 15
    },
    {
      "id": "es-16",
      "symbol": "p",
      "points": 3,
      "group": "consonant",
      "weight": 2.44,
      "enabled": true,
      "sortOrder": 16
    },
    {
      "id": "es-17",
      "symbol": "q",
      "points": 5,
      "group": "consonant",
      "weight": 0.46,
      "enabled": true,
      "sortOrder": 17
    },
    {
      "id": "es-18",
      "symbol": "r",
      "points": 1,
      "group": "consonant",
      "weight": 9.42,
      "enabled": true,
      "sortOrder": 18
    },
    {
      "id": "es-19",
      "symbol": "s",
      "points": 2,
      "group": "consonant",
      "weight": 3.96,
      "enabled": true,
      "sortOrder": 19
    },
    {
      "id": "es-20",
      "symbol": "t",
      "points": 2,
      "group": "consonant",
      "weight": 5.03,
      "enabled": true,
      "sortOrder": 20
    },
    {
      "id": "es-21",
      "symbol": "u",
      "points": 2,
      "group": "vowel",
      "weight": 3.51,
      "enabled": true,
      "sortOrder": 21
    },
    {
      "id": "es-22",
      "symbol": "v",
      "points": 4,
      "group": "consonant",
      "weight": 0.95,
      "enabled": true,
      "sortOrder": 22
    },
    {
      "id": "es-23",
      "symbol": "w",
      "points": 10,
      "group": "consonant",
      "weight": 0.25,
      "enabled": true,
      "sortOrder": 23
    },
    {
      "id": "es-24",
      "symbol": "x",
      "points": 8,
      "group": "consonant",
      "weight": 0.25,
      "enabled": true,
      "sortOrder": 24
    },
    {
      "id": "es-25",
      "symbol": "y",
      "points": 8,
      "group": "consonant",
      "weight": 0.25,
      "enabled": true,
      "sortOrder": 25
    },
    {
      "id": "es-26",
      "symbol": "z",
      "points": 4,
      "group": "consonant",
      "weight": 0.86,
      "enabled": true,
      "sortOrder": 26
    }
  ]
}
